<div class="card-header card-default">
  <ul class="actions top-left">
    <li>
      @if (!toggleTaskProcessing) {
        <mat-checkbox (click)="toggleTask($event)" [(ngModel)]="task.isDone"></mat-checkbox>
      }
      @if (toggleTaskProcessing) {
        <i class="material-icons">refresh</i>
      }
    </li>
  </ul>
  <ul class="actions icons top-right">
    <li>
      <a href="javascript:void(0)" (click)="deleteTask()"><i class="material-icons">delete</i></a>
    </li>
  </ul>
</div>
<div class="card-block">
  @if (!editable) {
    <span [ngClass]="task.isDone ? 'task-done' : 'task'" (click)="enableEditing()"
      style="cursor:pointer;">
      {{task.name}}
    </span>
  }
  @if (editable) {
    <form novalidate [formGroup]="form" (submit)="editName(form)">
      <div class="form-group"
        [ngClass]="form.get('updatedTask').hasError('required') && isSubmitted ? 'has-danger' : ''">
        <input type="text" class="form-control input-sm" id="task" placeholder="Add a task"
          formControlName="updatedTask" (blur)="disableEditing()" focus />
          @if (form.get('updatedTask').hasError('required') && isSubmitted) {
            <div class="form-control-feedback">
              Task
              name is required
            </div>
          }
        </div>
      </form>
    }
  </div>
